import { gql } from '@apollo/client';

export const CREATE_GAME_USER_INFO_GQL = gql`
  mutation createGameUserInfo($input: SignPayloadInput!) {
    createGameUserInfo(input: $input) {
      email
    }
  }
`;
